<template>
  <div class="page-wrapper py-4">
    <div id="master" ref="master" class="master" @scroll="handleScroll">
      <menutop :menu/>
      <FeedbackHeroNew id="page1" bg="white" class="section" />
      <AlertasFeedbackNew id="page2" bg="black" class="section" />
      <IAFeedbackNew id="page3" bg="black" class="section" />
      <ReportesFeedbackNew id="page4" bg="white" class="section" />
      <TituloServicioNew id="page5" bg="black" class="section" />
      <ReputacionFeedbackNew id="page6" bg="white" class="section" />
      <CincoEstrellasFeedbackNew id="page7" bg="white" class="section" />
      <AutoCalificaFeedbackNew id="page8" bg="white" class="section" />
      <TestimonioFeedbackNew id="page9" bg="white" class="section" />
      <CallToActionFeedbackNew id="page10" bg="white" class="section" />
      <FooterFeedbackNew id="page11" bg="black" class="section" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import menutop from '@/components/structure/menutop.vue'
import FeedbackHeroNew from '@/components/pages/feedback/FeedbackHeroNew.vue'
import AlertasFeedbackNew from '@/components/pages/feedback/AlertasFeedbackNew.vue'
import IAFeedbackNew from '@/components/pages/feedback/IAFeedbackNew.vue'
import ReportesFeedbackNew from '@/components/pages/feedback/ReportesFeedbackNew.vue'
import TituloServicioNew from '@/components/pages/feedback/TituloServicioNew.vue'
import ReputacionFeedbackNew from '@/components/pages/feedback/ReputacionFeedbackNew.vue'
import CincoEstrellasFeedbackNew from '@/components/pages/feedback/CincoEstrellasFeedbackNew.vue'
import AutoCalificaFeedbackNew from '@/components/pages/feedback/AutoCalificaFeedbackNew.vue'
import TestimonioFeedbackNew from '@/components/pages/feedback/TestimonioFeedbackNew.vue'
import CallToActionFeedbackNew from '@/components/pages/feedback/CallToActionFeedbackNew.vue'
import FooterFeedbackNew from '@/components/pages/feedback/FooterFeedbackNew.vue'

export default {
  name: 'feedbackView',
  props:{
      con: {
          default: {},
          type: Object
      }
  },
  components: {
    menutop,
    FeedbackHeroNew,
    AlertasFeedbackNew,
    IAFeedbackNew,
    ReportesFeedbackNew,
    TituloServicioNew,
    ReputacionFeedbackNew,
    CincoEstrellasFeedbackNew,
    AutoCalificaFeedbackNew,
    TestimonioFeedbackNew,
    CallToActionFeedbackNew,
    FooterFeedbackNew
  },
  watch: {
    currentSection() {
      if(document.getElementById(`page${this.currentSection}`)) {
        console.log(document.getElementById(`page${this.currentSection}`).getAttribute('bg'), this.currentSection);
        this.menu = document.getElementById(`page${this.currentSection}`).getAttribute('bg');
      }
    }
  },
  data() {
    return {
      menu: 'white',
      currentSection: 1,
    };
  },
  methods: {
    handleScroll() {
      const scrollPosition = this.$refs.master.scrollTop;
      const windowHeight = window.innerHeight;
      const menuHeight = 80; // Altura del menutop
      const adjustedScrollPosition = scrollPosition + menuHeight;
      const section = Math.floor(adjustedScrollPosition  / windowHeight) + 1;
      if (section < 1) {
        this.currentSection = 1;
      } else if (section > 11) {
        this.currentSection = 11;
      } else {
        this.currentSection = section;
      }
    },

  },
}
</script>

<style lang="css">
/* 1) El wrapper ocupa toda la pantalla */
.page-wrapper {
  background-color: #F0EFEB; /* background color */
  width: 100%;
  height: 96vh;
  display: flex;
  justify-content: center; /* centra .master horizontalmente */
  align-items: center;     /* centra .master verticalmente */
  box-sizing: border-box;
}

.master {
  margin-top: 16px !important;
  position: relative;
  background-color: #fff;
  border-radius: 16px;
  width: 97.95vw !important;
  height: 95.5vh !important;
  max-width: none;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-start;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);

  /* Firefox */
  scrollbar-width: none !important;
  /* IE 10+ */
  -ms-overflow-style: none !important;
}

/* Chrome, Safari, Opera */
.master::-webkit-scrollbar {
  display: none !important;
}


@media (max-width: 992px){
  .master {
      padding-top: 0px !important;
  }
}
</style>
